/**
 * @generated SignedSource<<35070b4a0b6a0bde615f262ac326b714>>
 * @relayHash 16b0555fb6e2de7506dc386cbae665c4
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/513.0.0-2025-06-02T16:47:36.215Z/MessageBannerQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageBannerQuery$variables = {
  hasPreviewVariables: boolean;
  hasRegisteredUserMessages: boolean;
  hasUnregisteredUserMessages: boolean;
  isFirstTimeVisitor: boolean;
  isGeoLocationPromoGroupSet: boolean;
  previewSetId: string;
  previewUserType: string;
  userId: string;
};
export type MessageBannerQuery$data = {
  readonly viewer: {
    readonly activePromotion: {
      readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_activePromotion">;
    } | null;
    readonly expiringPromotion: {
      readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_expiringPromotion">;
    } | null;
    readonly previewMessages?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_messages" | "sharedMessageHelpers_messages">;
    } | null> | null;
    readonly unregisteredUserMessages?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_messages" | "sharedMessageHelpers_messages">;
    } | null> | null;
    readonly user?: {
      readonly registeredUserMessages: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_messages" | "sharedMessageHelpers_messages">;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_viewer">;
  };
};
export type MessageBannerQuery = {
  response: MessageBannerQuery$data;
  variables: MessageBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasPreviewVariables"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasRegisteredUserMessages"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUnregisteredUserMessages"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFirstTimeVisitor"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGeoLocationPromoGroupSet"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "previewSetId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "previewUserType"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v8 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PromotionMeta",
  "kind": "LinkedField",
  "name": "promotionMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customBannerMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "desktopBannerMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "desktopBannerCta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileBannerMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileBannerCta",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PromotionMeta",
  "kind": "LinkedField",
  "name": "promotionMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urgencyMessagingDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urgencyMessagingDaysBeforeExpiration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "MessageBannerContent_messages"
  },
  {
    "kind": "InlineDataFragmentSpread",
    "name": "sharedMessageHelpers_messages",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageSetItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingMessage",
                "kind": "LinkedField",
                "name": "anchors",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "args": null,
    "argumentDefinitions": ([]/*: any*/)
  }
],
v17 = [
  {
    "kind": "Variable",
    "name": "isFirstTimeVisitor",
    "variableName": "isFirstTimeVisitor"
  }
],
v18 = [
  {
    "kind": "Variable",
    "name": "setId",
    "variableName": "previewSetId"
  },
  {
    "kind": "Variable",
    "name": "userType",
    "variableName": "previewUserType"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "FlatAdjustmentRate",
  "kind": "LinkedField",
  "name": "flatAdjustmentRate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            },
            (v19/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "kind": "LinkedField",
      "name": "cta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MessageSetItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketingMessage",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "kind": "LinkedField",
            "name": "anchors",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v23/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageBannerContent_viewer"
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "sharedMessageHelpers_activePromotion",
                "selections": [
                  (v10/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "expiringPromotion",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "sharedMessageHelpers_expiringPromotion",
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "expiringPromoMessageHelpers_expiringPromotion",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          },
          {
            "condition": "hasRegisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MessageBannerContent_user"
                  },
                  {
                    "alias": "registeredUserMessages",
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "kind": "LinkedField",
                    "name": "bannerMessages",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasUnregisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "unregisteredUserMessages",
                "args": (v17/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasPreviewVariables",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "previewMessages",
                "args": (v18/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "MessageBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "buyerDisplayable",
                "storageKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/),
              (v10/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "expiringPromotion",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PercentAdjustmentRate",
                "kind": "LinkedField",
                "name": "percentAdjustmentRate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rate",
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "isGeoLocationPromoGroupSet",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "listTypes",
                    "value": [
                      "ABTEST_PROMOTIONS"
                    ]
                  },
                  (v8/*: any*/)
                ],
                "concreteType": "PromotionVariantControl",
                "kind": "LinkedField",
                "name": "promotionVariantControl",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "promoGroup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "promotionCode",
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasRegisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "registeredUserMessages",
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "kind": "LinkedField",
                    "name": "bannerMessages",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasUnregisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "unregisteredUserMessages",
                "args": (v17/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasPreviewVariables",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "previewMessages",
                "args": (v18/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              }
            ]
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/513.0.0-2025-06-02T16:47:36.215Z/MessageBannerQuery",
    "metadata": {},
    "name": "MessageBannerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9778925794fa7e6b6adf29597973e65d";

export default node;
